import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import TVPricingItemBlockData from 'app/Models/Content/TVPricingItemBlockData';
import IconBlockData from 'Models/Content/IconBlockData';
import React from 'react';
import {getImageProps} from 'app/utilities/ImageProps';

const TVPricingItemBlock = ({data, context}: ComponentProps<TVPricingItemBlockData>) => (
  <a href={data.buttonLink.value} className='TVPricingItemBlock'>
    <h3 className='TVPricingItemBlock__name'>{data.name.value}</h3>

    <div className='TVPricingItemBlock__price'>
      {data.price?.value > 0 && (
        <>
          <span className='TVPricingItemBlock__price__value'>
            <span className='TVPricingItemBlock__price__value__ils'>₪</span>
            {data.price.value}
          </span>

          <span className='TVPricingItemBlock__price__monthly'>לחודש</span>
        </>
      )}

      {data.fullPrice?.value > 0 ? <span className='TVPricingItemBlock__price__full-price'>₪{data.fullPrice.value}</span> : null}
    </div>

    <div className='TVPricingItemBlock__logos'>
      {data.icons.expandedValue?.map(({image, description}: IconBlockData, i) => (
        <div className='TVPricingItemBlock__logos__logo-and-title'>
          {image.value && <Image key={i} {...getImageProps(image, context)} />}

          {description?.value && <span className='TVPricingItemBlock__logos__logo-and-title__title'>{description.value}</span>}
        </div>
      ))}
    </div>
    <div className='TVPricingItemBlock__description'>{data.description.value}</div>

    <div className='TVPricingItemBlock__button'>
      {data.buttonLinkTitle.value || 'לפרטים'} <Image src={require('./images/icons.svg')} />
    </div>
  </a>
);

export default TVPricingItemBlock;
